__webpack_require__.p = "/notes-data/onboarding/";